import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ForgeAutocomplete } from '@tylertech/forge-react';
import TextFieldWrapper from '../TextFieldWrapper/TextFieldWrapper.js';
import { addCompoundFilterOptionAndSelectFilter, compoundAutocompleteValue, getAllCompoundFilterValuesWithPaging, removeCompoundFilters, selectCompoundFilter } from './filterHelpers.js';
import { ABBREVIATION } from '../../../static/keyWords.js';

const STEP = 10;

const SingleCompoundFilter = ({option, setting, innerAppliedFilters, setInnerAppliedFilters}) => {
  const [offset, setOffset] = useState(0);
  const ref = useRef(null);
  const FILTER_NAME = `filter_${setting.type}_${option.label}`;

  useEffect(() => {
    const el = ref.current;

    if (!el) return;

    const onEvent = () => {
      setOffset(0);
    };

    el.addEventListener('focusout', onEvent);
    return () => {
      el.removeEventListener('focusout', onEvent);
    };
  }, []);

  const handleChange = (e, option, innerAppliedFilters) => {
    const selectedFilters = e.detail;
    const type = setting.type;
    const name = option[ABBREVIATION];
    const foundAppliedFilterIndex = innerAppliedFilters.findIndex(
      (x) => x.type === type
    );
    // 'X Clear' pressed on the dropdown
    if (selectedFilters.length === 0 && foundAppliedFilterIndex > -1) {
      removeCompoundFilters(
        setInnerAppliedFilters,
        innerAppliedFilters,
        foundAppliedFilterIndex,
        name
      );

      // Selected more filters
    } else if (selectedFilters.length > 0 && foundAppliedFilterIndex > -1) {
      selectCompoundFilter(
        setInnerAppliedFilters,
        innerAppliedFilters,
        foundAppliedFilterIndex,
        selectedFilters,
        name
      );

      // Selected filters for the first time for this dropdown
    } else if (selectedFilters.length > 0) {
      addCompoundFilterOptionAndSelectFilter(
        setInnerAppliedFilters,
        innerAppliedFilters,
        type,
        name,
        selectedFilters
      );
    }
  };

  const handleFilter = (value, options) => {
    return options
      .map(filterOption => {
        return { label: filterOption.value.name, value: { name: filterOption.value.name, id: filterOption.value.id } };
      })
      .filter(filterOption => filterOption.label.toLowerCase().includes(value.toLowerCase().trim()))
      .slice(0, STEP);
  };

  return (
    <ForgeAutocomplete
      id={FILTER_NAME}
      ref={ref}
      multiple
      filter={(value) => handleFilter(value, getAllCompoundFilterValuesWithPaging(innerAppliedFilters, setting, option))}
      on-forge-autocomplete-change={(e) =>
        handleChange(e, option, innerAppliedFilters)
      }
      value={compoundAutocompleteValue(innerAppliedFilters, setting, option)}
      syncPopupWidth={true}
      className="filter"
      observeScroll
      on-forge-autocomplete-scrolled-bottom={() => {
        const newOffset = offset + STEP;

        const autocomplete = document.getElementById(FILTER_NAME);
        const newOptions = option.value.slice(newOffset, newOffset + STEP).map(filterOption => {
          return { label: filterOption.value.name, value: { name: filterOption.value.name, id: filterOption.value.id } };
        });
        autocomplete.appendOptions(newOptions);

        setOffset(newOffset);
      }}
    >
      <TextFieldWrapper
        popoverIcon
        showClear
        inputId={`${option.label}__${setting.type}`}
        htmlFor={`${option.label}__${setting.type}`}
        label={option.label}
      />
    </ForgeAutocomplete>
  );
};

SingleCompoundFilter.propTypes = {
  option: PropTypes.object,
  setting: PropTypes.object,
  innerAppliedFilters: PropTypes.array,
  setInnerAppliedFilters: PropTypes.func,
};

export default SingleCompoundFilter;
